/* global module, require */
const THREE = require('three'),
	typeface = require('../../res/montserrat-subset.json'),
	unit = require('../unit');

const font = new THREE.Font(typeface),
	mat = new THREE.MeshBasicMaterial({ color: 0 });

module.exports = function makeFancySectionLabel(planner, start, end, n) {
	const length = start.distanceTo(end);
	const displaylength = Math.round(unit.mmReverse(length));
	const between = new THREE.Vector3().copy(end).sub(start);

	const geo = new THREE.TextBufferGeometry(
		`${planner.call('getSectionName', n, true)} ${displaylength}mm`,
		{
			font,
			size: 1,
			height: 0.05,
			curveSegments: 1,
		}
	).center();
	const mesh = new THREE.Mesh(geo, mat);

	// centre in section
	mesh.position
		.copy(start)
		.add(end)
		.multiplyScalar(0.5);

	// move above section
	mesh.position.y += unit.m(1.4);

	// always face camera
	mesh.onBeforeRender = function(renderer, scene, camera) {
		this.quaternion.copy(camera.quaternion);
	};

	return mesh;
};
